module.exports = __webpack_public_path__ + "media/CONCLUSION.84664062.mp4";